import { useSelector } from 'react-redux';

import { ISG_REPORT_VIEW_OPTIONS } from '../../../../../utils/constants';
import {
  hasTimeAccommodationException,
  shouldShowDueDateExceptionIcon,
} from '../../utils';
import s from './AdditionalMetrics.module.css';
import { Fragment } from 'react';

const hasDueDateException = (assignment) => {
  return shouldShowDueDateExceptionIcon(assignment);
};

const isLateAssignment = (assignment) => {
  return assignment.receivedLatePenalty;
};

const getAssignmentsForCategoryUsingStudents = (
  students,
  categoryId,
  currentView,
) => {
  if (
    categoryId &&
    students.length > 0 &&
    currentView === ISG_REPORT_VIEW_OPTIONS.CATEGORY
  ) {
    return students.flatMap((student) =>
      (student.assignments || []).filter(
        (assignment) => assignment.gradebook_category_id === categoryId,
      ),
    );
  }

  return [];
};

const countByPredicate = (assignments, predicateFn) =>
  assignments.filter(predicateFn).length;

export const AdditionalMetrics = ({ currentView, sectionData, isMobile }) => {
  const students = useSelector((state) => state.gradebook.students) || [];
  const sectionId = sectionData?.id;

  let assignments =
    sectionData?.assignments ??
    getAssignmentsForCategoryUsingStudents(students, sectionId, currentView) ??
    [];

  const metricsData = {
    lateAssignments: countByPredicate(assignments, isLateAssignment),
    dueDateExceptions: countByPredicate(assignments, hasDueDateException),
    timeAccommodations: countByPredicate(
      assignments,
      hasTimeAccommodationException,
    ),
  };

  return (
    <Fragment>
      {isMobile && <hr className={s.upperDivider} />}
      <div className={s.additionalMetricsContainer}>
        <h4 className={s.label}>Additional Metrics</h4>
        <div className={s.chips}>
          <div className={s.chip}>
            <span className={s.count}>{metricsData.lateAssignments}</span> late
            assignments
          </div>
          <div className={s.chip}>
            <span className={s.count}>{metricsData.dueDateExceptions}</span> due
            date exceptions
          </div>
          <div className={s.chip}>
            <span className={s.count}>{metricsData.timeAccommodations}</span>{' '}
            time accommodations
          </div>
        </div>
      </div>
    </Fragment>
  );
};
